import { DeltaJson, DeltaJsonOpsRow } from '@/models';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  deltaJson: DeltaJson;
  keyPrefix: string;
};
export const DeltaJsonElement = ({ deltaJson, keyPrefix }: Props) => {
  const ops = deltaJson.ops;
  return (
    <>
      {ops.map((opsRow, i) => (
        <Fragment key={`${keyPrefix}_${i}`}>
          <DeltaJsonOpsElement opsRow={opsRow} />
        </Fragment>
      ))}
    </>
  );
};

type OpsProps = {
  opsRow: DeltaJsonOpsRow;
};

const DeltaJsonOpsElement = ({ opsRow }: OpsProps) => {
  if (opsRow.attributes == null) {
    return <span style={{ whiteSpace: 'pre-wrap' }}>{opsRow.insert}</span>;
  }

  let styles: any = {};
  if (opsRow.attributes.bold) {
    styles['fontWeight'] = 700;
  }
  if (opsRow.attributes.italic) {
    styles['fontStyle'] = 'italic';
  }

  if (opsRow.attributes.link) {
    return (
      <span style={styles}>
        <Link to={opsRow.attributes.link}>{opsRow.insert}</Link>
      </span>
    );
  } else {
    return <span style={styles}>{opsRow.insert}</span>;
  }
};
